<template>
  <div class="pieChartWrapper">
    <div class="malePie" v-bind:style="style.maleConicGradient"></div>
    <div class="femalePie" v-bind:style="style.femaleConicGradient"></div>
    <div class="unknownPie" v-bind:style="style.unknownConicGradient"></div>
    <div class="maleLabelText" v-if="isLabelTextShow[0]" v-bind:style="style.maleLabelText">
      <span class="label">{{data[0].label}}</span>
      <span class="value">{{data[0].value + '%'}}</span>
    </div>
    <div class="femaleLabelText" v-if="isLabelTextShow[1]" v-bind:style="style.femaleLabelText">
      <span class="label">{{data[1].label}}</span>
      <span class="value">{{data[1].value + '%'}}</span>
    </div>
    <div class="unknownLabelText" v-if="isLabelTextShow[2]" v-bind:style="style.unknownLabelText">
      <span class="label">{{data[2].label}}</span>
      <span class="value">{{data[2].value + '%'}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chartDataProp: Array
  },
  data () {
    return {
      data: null,
      dataExistCount: null,
      isLabelTextShow: [
        false,
        false,
        false
      ],
      style: {
        maleConicGradient: '',
        femaleConicGradient: '',
        unknownConicGradient: '',
        maleLabelText: '',
        femaleLabelText: '',
        unknownLabelText: ''
      }
    }
  },
  methods: {
    setDataExistCount: function (data) {
      let dataExistCount = 0
      for(var i = 0; i < data.length; i++) {
        dataExistCount += data[i].value !== 0 ? 1 : 0
      }
      this.dataExistCount = dataExistCount
    },
    setPieConicGradient: function (data, dataExistCount) {
      if(dataExistCount !== 0) {
        // 남성, 여성, 성별모름 데이터가 전부 0인 경우 제외
        let accumulated = 0
        for(var i = 0; i < data.length; i++) {
          if(i === 0) {
            this.style.maleConicGradient = 'background: conic-gradient(transparent 0% ' + accumulated + '%, #000000 ' + accumulated + '% '
            accumulated += data[i].value
            this.style.maleConicGradient += accumulated + '%, transparent ' + accumulated + '%);'
          }else if (i === 1) {
            this.style.femaleConicGradient = 'background: conic-gradient(transparent 0% ' + accumulated + '%, #0099FF ' + accumulated + '% '
            accumulated += data[i].value
            this.style.femaleConicGradient += accumulated + '%, transparent ' + accumulated + '%);'
          }else {
            this.style.unknownConicGradient = 'background: conic-gradient(transparent 0% ' + accumulated + '%, #C7C7C7 ' + accumulated + '% '
            accumulated += data[i].value
            this.style.unknownConicGradient += accumulated + '%, transparent ' + accumulated + '%);'
          }
        }
      }else {
        // 남성, 여성, 성별모름 데이터가 전부 0인 경우
        this.style.maleConicGradient = 'width: 238px; height: 238px; top: 0; left: 0; '
        this.style.maleConicGradient += 'background: conic-gradient(transparent 0% 0%, #F2F2F2 0% 33.3%, transparent 33.3%);'
        this.style.femaleConicGradient = 'width: 238px; height: 238px; top: 0; left: 0; '
        this.style.femaleConicGradient += 'background: conic-gradient(transparent 0% 33.3%, #F2F2F2 33.3% 66.6%, transparent 66.6%);'
        this.style.unknownConicGradient = 'width: 238px; height: 238px; top: 0; left: 0; '
        this.style.unknownConicGradient += 'background: conic-gradient(transparent 0% 66.6%, #F2F2F2 66.6%);'
      }
    },
    setLabelTextPosition: function (data, dataExistCount) {
      let accumulated = 0
      if(dataExistCount === 0) {
        // 데이터가 전부 0일 경우
        for(var i = 0; i < data.length; i++) {
          this.isLabelTextShow[i] = true
          let returnValue = this.setLabelText(i, 119, 27, accumulated, 33.3)
          accumulated += returnValue
        }
      } else if(dataExistCount === 1) {
        // 0이 아닌 데이터가 1개일 경우, 0인 데이터는 표시하지 않음
        // eslint-disable-next-line no-redeclare
        for(var i = 0; i < data.length; i++) {
          if(data[i].value !== 0) {
            this.isLabelTextShow[i] = true
            let returnValue = this.setLabelText(i, 119 - (i * 5), 27, accumulated, data[i].value)
            accumulated += returnValue
          }
        }
      } else{
        // 0이 아닌 데이터가 2개 or 3개일 경우, 0인 데이터도 표시함
        // eslint-disable-next-line no-redeclare
        for(var i = 0; i < data.length; i++) {
          this.isLabelTextShow[i] = true
          let returnValue = this.setLabelText(i, 119 - (i * 5), 27, accumulated, data[i].value)
          accumulated += returnValue
        }
      }
    },
    getAngle: function (value) {
      return 360 * value / 100
    },
    getXYPosition: function (radius, startAngle, endAngle) {
      let angle = (endAngle + startAngle) / 2
      let x = radius * Math.sin(Math.PI * 2 * angle / 360)
      let y = radius * Math.cos(Math.PI * 2 * angle / 360)
      return {x: x, y: y}
    },
    setLabelText: function (type, chartRadius, labelDivRadius, accumulated, value) {
      let position = this.getXYPosition(chartRadius, this.getAngle(accumulated), this.getAngle(accumulated + value))
      let labelPositionX = position.x - labelDivRadius + chartRadius < 0 ? 0 : position.x - labelDivRadius + chartRadius
      let labelPositionY = (-position.y - labelDivRadius) + chartRadius

      if(type === 0) {
        this.style.maleLabelText = 'top: ' + labelPositionY + 'px; ' + 'left: ' + labelPositionX + 'px;'
      }else if(type === 1) {
        this.style.femaleLabelText = 'top: ' + labelPositionY + 'px; ' + 'left: ' + labelPositionX + 'px;'
      }else {
        this.style.unknownLabelText = 'top: ' + labelPositionY + 'px; ' + 'left: ' + labelPositionX + 'px;'
      }

      return value
    }
  },
  watch: {
    chartDataProp: function () {
      this.data = this.chartDataProp
      this.setDataExistCount(this.data)
      this.setPieConicGradient(this.data, this.dataExistCount)
      this.setLabelTextPosition(this.data, this.dataExistCount)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.pieChartWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.malePie {
  position: absolute;
  top: 0;
  left: 0;
  width: 238px;
  height: 238px;
  border-radius: 50%;
}

.femalePie {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 228px;
  height: 228px;
  border-radius: 50%;
}

.unknownPie {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 218px;
  height: 218px;
  border-radius: 50%;
}

.maleLabelText, .femaleLabelText, .unknownLabelText{
  position: absolute;
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 54px;
  height: 54px;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/pieChart.vue